export default __webpack_public_path__ + "static/media/ent.7fb297d9.svg";